var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteDataFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999349 13.8333C0.999349 14.75 1.74935 15.5 2.66602 15.5H9.33268C10.2493 15.5 10.9993 14.75 10.9993 13.8333V3.83333H0.999349V13.8333ZM11.8327 1.33333H8.91602L8.08268 0.5H3.91602L3.08268 1.33333H0.166016V3H11.8327V1.33333Z",
    fill: "#FF4545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDataFilter);
export default __webpack_public_path__ + "static/media/delete_data_filter.cff17bb36048ec828bfbc5b344b70703.svg";
export { ForwardRef as ReactComponent };